import React, { useState, useEffect } from "react";
import axios from "axios";
import { TriangleAlert } from "lucide-react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const ImportantNewsSection = () => {
  const navigate = useNavigate();
  const [messages, setMessages] = useState([]);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [messagesRes, settingsRes] = await Promise.all([
          axios.get('/api/admin/important-news/active'),
          axios.get('/api/admin/important-news/settings')
        ]);

        if (messagesRes.data.success) {
          setMessages(messagesRes.data.data);
        }
        if (settingsRes.data.success) {
          setSettings(settingsRes.data.data);
        }
      } catch (error) {
        console.error('Error fetching important news:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Don't render if loading, no messages, or section is hidden
  if (loading || messages.length === 0 || (settings && !settings.is_section_visible)) {
    return null;
  }

  const bgColor = settings?.background_color || 'red-100';
  const textColor = settings?.text_color || 'red-600';
  const speed = settings?.marquee_speed || 50;

  return (
    <div
      id="important-news"
      onClick={() => navigate("/home-loan-blog-aham-housing-finance")}
      className={`bg-${bgColor} border-y border-${textColor.replace('-600', '-300')} py-3 overflow-hidden cursor-pointer`}
    >
      <div className="container mx-auto px-4 flex items-center gap-3">
        <TriangleAlert className="text-yellow-700 w-5 h-5 flex-shrink-0" />

        {/* Marquee Wrapper */}
        <div className="relative w-full overflow-hidden">
          <motion.div
            className="flex gap-16 whitespace-nowrap"
            animate={{ x: ["100%", "-100%"] }}
            transition={{
              repeat: Infinity,
              duration: speed,
              ease: "linear",
            }}
          >
            {[...messages, ...messages].map((msg, idx) => (
              <p key={idx} className={`text-${textColor} font-medium text-sm md:text-base`}>
                {msg.message}
              </p>
            ))}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default ImportantNewsSection;
